import { render, staticRenderFns } from "./importSet.vue?vue&type=template&id=2607f100&scoped=true&lang=pug"
import script from "./importSet.vue?vue&type=script&lang=js"
export * from "./importSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2607f100",
  null
  
)

export default component.exports